










import {Component, Prop, Model} from 'vue-property-decorator';
import Vue from 'vue';
import {
  isValidPhoneNumber,
} from 'libphonenumber-js'

@Component({})
export default class UiPhoneInput extends Vue {
  innerErrors = [];

  @Model('change')
  modelValue: any

  @Prop()
  value: any;

  @Prop({ default: '' })
  label: string;

  @Prop()
  placeholder: string;

  @Prop()
  labelHelp: string;

  @Prop({ default: [] })
  errorMessages: [];

  get model() {
    return this.modelValue
  }

  set model(value) {
    this.$emit('change', value)
  }
  
  get errorsMsg() {
    return [...this.innerErrors,...this.errorMessages][0]
  }

  onBlur() {
    this.$emit('blur', this.model);
    if(isValidPhoneNumber(this.model)||!this.model){
      this.$emit('valid', true);
      this.innerErrors= [];
    }else{
      this.$emit('valid', false);
      this.innerErrors=[this.t('Phone number should contain country code with + and correct amount of digits, e.g. +1 541 754 3010')]
    }
  }
}
